export default "__VITE_ASSET__BFfQ1kBt__"